// Центральное место для всех SQL-запросов. Без скрытых вставок в коде.

export const Q = {
  // Список с фильтрами. Используем json_each для in-параметров;
  // bind принимает либо строку JSON, либо NULL чтобы фильтр выключился.
  list: `
    SELECT i.pk, i.slug, i.kind, i.name_en, i.name_ru, i.quality, i.type,
           i.sprite_x, i.sprite_y
    FROM items i
    WHERE (@kind IS NULL OR i.kind = @kind)
      AND (@quality_json IS NULL
           OR i.quality IN (SELECT CAST(value AS INTEGER) FROM json_each(@quality_json)))
      AND (@pools_json IS NULL OR EXISTS (
        SELECT 1 FROM item_pools ip
        JOIN pools p ON p.id = ip.pool_id
        WHERE ip.item_pk = i.pk
          AND p.slug IN (SELECT value FROM json_each(@pools_json))
      ))
      AND (@colors_json IS NULL OR EXISTS (
        SELECT 1 FROM item_tags it
        JOIN tags t ON t.id = it.tag_id
        WHERE it.item_pk = i.pk AND t.category = 'color'
          AND t.slug IN (SELECT value FROM json_each(@colors_json))
      ))
      AND (@search IS NULL
           OR i.pk IN (SELECT rowid FROM items_fts WHERE items_fts MATCH @search))
    ORDER BY
      CASE @sort WHEN 'name'     THEN i.name_en END ASC,
      CASE @sort WHEN 'quality'  THEN -COALESCE(i.quality, -1) END ASC,
      i.kind, i.game_id
    LIMIT @limit OFFSET @offset
  `,

  // Сколько строк попадает под текущий фильтр.
  count: `
    SELECT COUNT(*) AS n FROM items i
    WHERE (@kind IS NULL OR i.kind = @kind)
      AND (@quality_json IS NULL
           OR i.quality IN (SELECT CAST(value AS INTEGER) FROM json_each(@quality_json)))
      AND (@pools_json IS NULL OR EXISTS (
        SELECT 1 FROM item_pools ip
        JOIN pools p ON p.id = ip.pool_id
        WHERE ip.item_pk = i.pk
          AND p.slug IN (SELECT value FROM json_each(@pools_json))
      ))
      AND (@colors_json IS NULL OR EXISTS (
        SELECT 1 FROM item_tags it
        JOIN tags t ON t.id = it.tag_id
        WHERE it.item_pk = i.pk AND t.category = 'color'
          AND t.slug IN (SELECT value FROM json_each(@colors_json))
      ))
      AND (@search IS NULL
           OR i.pk IN (SELECT rowid FROM items_fts WHERE items_fts MATCH @search))
  `,

  // Одна запись для модалки.
  one: `
    SELECT i.pk, i.slug, i.kind, i.name_en, i.name_ru, i.quality, i.type,
           i.sprite_x, i.sprite_y,
           i.description_ru, i.ingame_text, i.unlock,
           i.charges, i.charge_type, i.dlc,
           i.source_dg_url, i.source_ii_url
    FROM items i WHERE i.slug = @slug
  `,

  itemPools: `
    SELECT p.slug, p.name_ru
    FROM item_pools ip
    JOIN pools p ON p.id = ip.pool_id
    JOIN items i ON i.pk = ip.item_pk
    WHERE i.slug = @slug
    ORDER BY p.name_ru
  `,

  itemNotes: `
    SELECT kind, body FROM item_notes
    WHERE item_pk = (SELECT pk FROM items WHERE slug = @slug)
    ORDER BY kind
  `,

  itemStats: `
    SELECT stat, flat, mult FROM item_stats
    WHERE item_pk = (SELECT pk FROM items WHERE slug = @slug)
  `,

  itemTags: `
    SELECT t.slug, t.name, t.category
    FROM item_tags it
    JOIN tags t ON t.id = it.tag_id
    WHERE it.item_pk = (SELECT pk FROM items WHERE slug = @slug)
  `,

  poolsAll: `
    SELECT p.slug, p.name_ru, p.name_en
    FROM pools p
    JOIN item_pools ip ON ip.pool_id = p.id
    GROUP BY p.id
    ORDER BY p.name_ru
  `,

  // Лёгкая выборка по pk-списку (для матчера scanner'а).
  byPks: `
    SELECT i.pk, i.slug, i.kind, i.name_en, i.name_ru, i.quality, i.type,
           i.sprite_x, i.sprite_y
    FROM items i
    WHERE i.pk IN (SELECT CAST(value AS INTEGER) FROM json_each(@pks_json))
  `,

  // Координаты всех спрайтов в порядке pk — для построения референсов сканера.
  allRefs: `
    SELECT i.pk, i.kind, i.sprite_x, i.sprite_y FROM items i ORDER BY i.pk
  `,

  // Резолв `item:[X]` ссылок из описаний — ищем по name_en, попутно ловим name_ru.
  resolveRefs: `
    SELECT i.name_en, i.name_ru, i.slug
    FROM items i
    WHERE i.name_en IN (SELECT value FROM json_each(@names_json))
  `,
};

// FTS5 принимает запрос с операторами. Преобразуем user input в безопасный
// prefix-запрос: "sad onion" → "sad* onion*" с экранированием кавычек.
export function toFtsQuery(input: string): string | null {
  const tokens = input
    .trim()
    .replace(/["]/g, ' ')
    .split(/\s+/)
    .filter((t) => t.length >= 2);
  if (tokens.length === 0) return null;
  return tokens.map((t) => `"${t.replace(/[^\p{L}\p{N}]/gu, '')}"*`).join(' ');
}
